import './js/header';
import './js/mobile-menu';
import './js/dark-theme';
import './js/top-books';
import './js/books-by-category';
import './js/category-list';
import './js/modal';
import './js/foundations';
import './js/scroll-up';
